export default __webpack_public_path__ + "hero-next-1687-26256834e089e0a148efd7262f00619f.bundle.webp";